import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import * as styles from './Notification.css';

export interface INotificationProps {
  message: string;
  onClick?(): void;
}

export const Notification: React.FC<INotificationProps> = ({ message, onClick }) => {
  return (
    <div className={styles['container']} onClick={onClick}>
      <UIText2 color="white_100">{message}</UIText2>
    </div>
  );
};
